import detailStyles from '../ChallengeDetail.module.scss';
import image61 from './images/6-1.jpg';
import image62 from './images/6-2.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const GetSalaryDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Офис»</b>
                </div>
                <ChallengeDetailHelpImage image={image61} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Нажмите большую зеленую кнопку <b>«Получить зарплату»</b>
                </div>
                <ChallengeDetailHelpImage image={image62} helpText='Это картинка. Ищите кнопку в разделе «Офис».' />
            </p>
        </div>
    );
}